import type * as React from 'react';

/**
 Generated using: https://react-svgr.com/playground

 How to import new SVGs:
 1. open the SVG in a text editor
 2. copy the <svg ...>  </svg> portion and replace the same section in this file, keeping the {...props}
 3. remove xmlns:xlink attribute from root svg element
 4. replace all xlink:href attributes with href
 5. replace all `fontFamily="Roboto-????, Roboto"` with matching `fontFamily="Roboto-????, Roboto, Helvetica Neue, HelveticaNeue, Helvetica, Arial, sans-serif"`
*/

const Success = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={140}
    height={121}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M70 74.2c18.667 0 33.8-15.133 33.8-33.8 0-18.667-15.133-33.8-33.8-33.8-18.667 0-33.8 15.133-33.8 33.8 0 18.667 15.133 33.8 33.8 33.8Z"
        fill="#D6EDF7"
      />
      <path
        d="m86.9 18.5 7.4-8.8M53.7 18.5l-7.4-8.8M65.8 12.2 62.1 1.8M75.3 12.2 79 1.8"
        stroke="#2665CF"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M24.4 98.7c5.4 0 10.6.2 15.6.4 1.2.1 2.1 1.1 2.1 2.3v16.9c0 1.2-.9 2.2-2.1 2.3-4.9.3-10.2.4-15.6.4s-10.6-.2-15.6-.4c-1.2-.1-2.1-1.1-2.1-2.3v-16.9c0-1.2.9-2.2 2.1-2.3 5-.2 10.2-.4 15.6-.4ZM116.1 98.7c-5.4 0-10.6.2-15.6.4-1.2.1-2.1 1.1-2.1 2.3v16.9c0 1.2.9 2.2 2.1 2.3 4.9.3 10.2.4 15.6.4s10.6-.2 15.6-.4c1.2-.1 2.1-1.1 2.1-2.3v-16.9c0-1.2-.9-2.2-2.1-2.3-5-.2-10.3-.4-15.6-.4Z"
        fill="#D6EDF7"
      />
      <path
        d="M21.8 34.3v-5.6c0-2.9-2.3-6.9-5.2-6.9-3 0-5.2 4-5.2 6.9v33.8M32.2 28.8v-5.3c0-2.9-2.7-6.9-5.2-6.9s-5.2 4-5.2 6.9v36.4M32.2 58.6V28.8c0-7 3.4-9.4 5.2-9.4 2 0 5.2 3 5.2 10.6v25.5M11.4 42.1v-3.2c0-4.2-2.9-7.7-5.2-7.7-2.1 0-5.2 3.2-5.2 7.7v27.2c0 5 1 19.6 7.9 28.8M101.3 96.6c-8-3.2-14.6-9.6-18.5-20.9l-6.2-21.6c-1-2.7 8.5-5.5 11.4 1.3l4.3 10.4c1.9 4.9 9.3 5.2 15.6 13.6M118.2 34.3v-5.6c0-2.9 2.3-6.9 5.2-6.9 3 0 5.2 4 5.2 6.9v33.8"
        stroke="#2665CF"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M107.8 28.8v-5.3c0-2.9 2.7-6.9 5.2-6.9s5.2 4 5.2 6.9v36.4M107.8 58.6V28.8c0-7-3.4-9.4-5.2-9.4-2 0-5.2 3-5.2 10.6v25.5M128.6 42.1v-3.2c0-4.2 2.9-7.7 5.2-7.7 2.1 0 5.2 3.2 5.2 7.7v27.2c0 5.4-2.4 20-9.2 29.5-3.9 5.4-4.1 16.7-4.1 16.7M34.8 114.4l.1-10c0-4.1 2.3-8 6-9.8 7-3.4 12.7-8.6 16.3-18.8l6.2-21.7c.9-2.8-8.5-5.5-11.2 1.3l-4.4 10.4c-1.9 4.9-15.4 5-20.9 17.8"
        stroke="#2665CF"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0h140v120.5H0z" />
      </clipPath>
    </defs>
  </svg>
);

export { Success };
